import _ from 'lodash';

import { getPrice } from "src/rules/calculation/priceCalculation";
import { ISelection } from "src/constants/interfaces/bet";
import { IClientConfig } from "src/client-config/config";
import { IPartnerConfig } from "src/constants/interfaces";
import { BetTypeEnum } from "src/constants/enums/betType";
import { getTotalOdd } from "src/rules/calculation/odd";
import { getEffectiveSelectionsCount } from "src/common/helpers/betBuilder";

export const hasProfitBoost = (
  config: IClientConfig,
  partnerConfig: IPartnerConfig | undefined,
  selections: ISelection[],
  betType: BetTypeEnum,
  stakeAmount: number,
) => {
  const totalOdd = getTotalOdd(config, partnerConfig, betType, selections) || 0;

  const minSelectionOddPasses = (
    !config.wheelConfig?.minSelectionOdd
    || selections.every((item) => getPrice(item) > config.wheelConfig!.minSelectionOdd)
  );

  // Bet builder cards collapse to ONE leg for selection-count rules —
  // a 4-leg BB card plus 1 standalone pick is 2 effective selections, not 5.
  // Same convention used by bet-type resolution, banker validation, and
  // the system-options dropdown.
  const effectiveCount = getEffectiveSelectionsCount(selections);

  return (
    config.wheelConfig &&
    effectiveCount >= config.wheelConfig.minSelectionsCount
    && minSelectionOddPasses
    && _.inRange(stakeAmount, config.wheelConfig.minStake, config.wheelConfig.maxStake || 100000000000000000)
    && _.inRange(totalOdd, config.wheelConfig.minOdd, config.wheelConfig.maxOdd || 100000000000000000)
  );
};
